import type { ExtensionConfig } from '@goto/shell'
import { getLaunchDarklyFlag } from '../helpers/shell-helpers'
import { LaunchDarklyVariations } from '../models/feature-flag.models'

const canOverrideExperiencePath = (version: string) => version !== 'latest'

export const getVoiceExperiencePath = () => {
  const version = getLaunchDarklyFlag(LaunchDarklyVariations.GTC_VOICE_EXPERIENCE_VERSION) ?? 'latest'

  // this string needs to exist on its own for feature branch deployments
  let path = '/experiences/voice/latest'

  if (canOverrideExperiencePath(version)) {
    path = `/experiences/voice/${version}`
  }
  return path
}

/**
 * Extension config
 */
const extensionConfig: ExtensionConfig = {
  id: '@voice',
  get url() {
    const path = getVoiceExperiencePath()
    return new URL(`${path}/extension.js`, location.origin)
  },
  unguardedRoutes: [],
  esModule: true,
}

export default extensionConfig
